import FormattedMessage from 'I18n/components/FormattedMessage';
import HubSpotAppLink from 'crm-links/common/components/HubSpotAppLink';
import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useProductId } from '../../contexts/ProductIdContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductHighlightViewPropertiesButton = () => {
  const productId = useProductId();
  if (!productId) {
    return null;
  }
  return /*#__PURE__*/_jsx(HubSpotAppLink, {
    linkType: "CRM_OBJECT_RECORD_ALL_PROPERTIES",
    linkTypeProps: {
      includeEschref: true,
      objectTypeId: PRODUCT_TYPE_ID,
      objectId: productId
    },
    LinkComponentProps: {
      'data-test-id': 'view-all-properties-button'
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actions.viewAllProperties"
    })
  });
};